import { useState, useEffect } from "react";
import { Input } from "antd";

export const LatLngInput = ({ latLng, setLatLng }) => {
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(`${latLng.lat}, ${latLng.lng}`);
  }, [latLng]);

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const parts = value.split(",").map((p) => p.trim());
    if (parts.length === 2) {
      const lat = parseFloat(parts[0]);
      const lng = parseFloat(parts[1]);
      if (!isNaN(lat) && !isNaN(lng)) {
        setLatLng({ lat, lng });
      }
    }
  };

  return (
    <Input
      value={inputValue}
      onChange={handleChange}
      placeholder="Lat, Lng (ej: 19.4326, -99.1332)"
      size="large"
    />
  );
};
